import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

export default function NotFound() {
  return (
    <div className="notfound-container">
      <h1 className="notfound-title">404 - Page Not Found</h1>
      <p className="notfound-message">Sorry, the page you are looking for does not exist.</p>
      <Link to="/" className="notfound-link">Go to Home</Link>
    </div>
  );
}
